import lerp from './lerp';
import invlerp from './invlerp';

const range = (x1, y1, x2, y2, a) => lerp(x2, y2, invlerp(x1, y1, a));

export default range;
export { range };